export enum  OkcVariables {
	TransactionType_FiscalProcess = 0,
	TransactionType_InfoProcess = 1,
	TransactionType_EArchive = 2,
	TransactionType_EInvoice = 3,
	NOT_SET = 0,
	PAIRING_REQUIRED = 1000,
	POS_HAS_UNCOMPLETED_PROCESS = 1001,
	TIMEOUT = 1002,
	CABLE_ERROR = 1003,
	NO_PAPER = 1005,
	GETTING_PAYMENT_APPLICATION_INFO_SUCCESS = 10,
	GETTING_PAYMENT_APPLICATION_INFO_FAILED = 11,
	PAYMENT_SUCCESS = 30,
	PAYMENT_INFO_NOT_RETURNED_FROM_DEVICE = 31,
	PAYMENT_FAILED = 32,
	PAYMENT_SUCCESS_BUT_NOT_PRINT_MF = 33,
	PAYMENT_FAILED_ON_FISCAL_PROCESS = 34,
	PAYMENT_FAILED_START_RETURN_PROCESS = 35,
	ITEMSALE_SUCCESS = 50,
	ITEMSALE_CANT_START = 51,
	ITEMSALE_TICKET_HEADER_NOT_PRINTED = 52,
	ITEMSALE_FAILED = 53,
	ITEMSALE_TAX_RATE_NOT_FOUND = 54,
	ITEMVOID_SUCCESS = 60,
	ITEMVOID_FAILED = 61,
	VOID_ALL_ITEM_SUCCESS = 70,
	VOID_ALL_ITEM_FAILED = 71,
	TRANSACTION_START_SUCCESS = 80,
	TRANSACTION_START_FAILED = 81,
	TRANSACTION_START_ALREADY_IN_TRANSCTION = 82,
	TRANSACTION_END_SUCCESS = 90,
	HANDSHAKE_SUCCESS = 100,
	HANDSHAKE_CONNECTION_FAIL = 101,
	HANDSHAKE_PAIRING_FAIL = 102,
	HANDSHAKE_GETTING_DEPARTMENT_FAIL = 103,
	HANDSHAKE_GETTING_CURRENCY_FAIL = 104,
	HANDSHAKE_FAILED = 106,
	ENDOFDAY_SUCCESS = 120,
	ENDOFDAY_FAILED = 121,
	CANCEL_PAYMENT_SUCCESS = 130,
	CANCEL_PAYMENT_FAILED = 131,
	CANCEL_PAYMENT_OUT_OF_PAYMENT_INDEX_RANGE = 132,
	Z_REPORT_SUCCESS = 140,
	Z_REPORT_FAILED = 141,
	Z_REPORT_NEED_ADMIN_PASSWORD = 142,
	X_REPORT_SUCCESS = 150,
	X_REPORT_FAILED = 151,
	X_REPORT_NEED_ADMIN_PASSWORD = 152,
	LAST_RECEIPT_SUCCESS = 160,
	LAST_RECEIPT_FAILED = 161,
	LAST_RECEIPT_NEED_ADMIN_PASSWORD = 162,
	VOID_PAYMENT_SUCCESS = 170,
	VOID_PAYMENT_FAILED = 171,
	VOID_PAYMENT_NO_BANK_APP_FOUND = 172,
	VOID_PAYMENT_BANK_APPS_ERROR = 173,
	VOID_PAYMENT_SELECTED_BANK_NOT_FOUND = 174,
	REFUND_PAYMENT_SUCCESS = 180,
	REFUND_PAYMENT_FAILED = 181,
	PRINT_FREE_TEXT_SUCCESS = 191,
	PRINT_FREE_TEXT_FAILED = 192,
	CASHIER_INFO_SUCCESS = 201,
	CASHIER_INFO_FAILED = 202,
	CASHIER_LOGOUT_SUCCESS = 211,
	CASHIER_LOGOUT_FAILED = 212,
	CASHIER_LOGON_SUCCESS = 221,
	CASHIER_LOGON_FAILED = 222,
	CASHIER_ADD_SUCCESS = 231,
	CASHIER_ADD_FAILED = 232,
	CANCEL_ALL_PAYMENT_SUCCESS = 241,
	CANCEL_ALL_PAYMENT_FAILED = 242,
	REFUD_SUCCESS = 251,
	REFUD_FAILED = 252,
	CANCEL_RECEIPT_SUCCESS = 261,
	CANCEL_RECEIPT_FAILED = 262,

	ReceiptMessageType_Size24 = 0,
	ReceiptMessageType_Size12 = 1,
	ReceiptMessageType_Size32 = 2,
	ReceiptMessageType_Size48 = 3,
	ReceiptMessageType_BOLD = 4,
	ReceiptMessageType_CENTER = 5,
	ReceiptMessageType_RIGHT = 6,
	ReceiptMessageType_INVERTED = 7,
	ReceiptMessageType_UNIQUE_ID = 8,
	ReceiptMessageType_BARCODE = 9,
	ReceiptMessageType_ECR_TICKET_HEADER = 10,
	ReceiptMessageType_GRAPHIC = 11,
	ReceiptMessageType_QRCODE = 12,
	ReceiptMessageType_Size16 = 13,
	ReceiptMessageType_Size38 = 14,

}


// WEBPACK FOOTER //
// ./src/app/classes/okc-variables.ts